import React from "react";

export function FullScreenLoading() {
    return (
        <div className="full_screen_loading">
            <img src={"/images/loading.gif"} alt={"loading"}/>
        </div>
    );
}